import { render, staticRenderFns } from "./Bodegas.vue?vue&type=template&id=007500fb"
import script from "./Bodegas.vue?vue&type=script&lang=js"
export * from "./Bodegas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports